import Vue from "vue"
import debounce from 'lodash/debounce'

/**
 * （废弃）
 */

Vue.component('k-search-input', {
    props: {
        get: Function,
        multiple: Boolean,
    },
    data() {
        this.fetch = debounce(this.fetchData, 500)
        return {
            hasFor: false,
            fetching: false,
            items: [],
            value: undefined,
        }
    },
    render() {
        
        const { multiple } = this.$props
        const { items, fetching } = this.$data
        const props = { ...this.$attrs, ...this.$props, ... {
            showSearch: true,
            labelInValue: true,
            filterOption: false,
            dropdownMatchSelectWidth: false,
            mode: multiple ? 'multiple' : 'default',
            notFoundContent: fetching ? <a-spin size="small" /> : null,
        }}
        const on = { ...this.$listeners }
        return <a-select ref="select" props={props}  on={on} onSearch={this.fetch}>
            {items.map(c => <a-select-option key={c.key} extra={{ ...c }}>
                {c.label}
            </a-select-option>)}
        </a-select>
    },
    methods: {
        // onChange(value, node) {
        //     let opt;
        //     if(node) {
        //         if (Array.isArray(node)) {
        //             opt = node.map(n => n.data.attrs.extra)
        //         } else {
        //             opt = node.data.attrs.extra
        //         }
        //     }
        //     this.value = value
        //     this.$emit('change', value, opt)
        // },
        async fetchData(value) {
            const { get } = this
            if (typeof get != "function") {
                console.error("attr get is not function ... ")
                return
            }
            this.fetching = true
            this.items = []
            try {
                this.items = await get(value)
            } catch (error) {
                console.error(error)
            }
            this.fetching = false
        }
    },
})